/**
 * How the Track Difference panel was last set up.
 *
 * Panels fully unmount whenever another panel is maximized, so without this the
 * height mode, scale and camera reset several times in an ordinary session. Held
 * in module scope rather than localStorage deliberately: this is "where I was a
 * moment ago", not a durable preference, and it should not outlive the tab.
 *
 * The pan centre is not kept. It is expressed in the fitted view's coordinates,
 * which move when the camera angle or the lap pair changes, so restoring it can
 * land the camera somewhere the track no longer is; zoom and follow re-derive a
 * sensible centre on their own.
 */
const prefs = {
  heightMode: 'gap',
  exaggeration: 'auto',
  sectorsByLoss: false,
  viewAngles: null,   // null = the view's own default
  zoom: 1,
  follow: false,
};

export function readTrackDifferencePrefs() {
  return { ...prefs };
}

export function writeTrackDifferencePrefs(next) {
  Object.assign(prefs, next);
}
